<mat-card appearance="outlined" [formGroup]="formGroup" class="chart" telemetry="Card-BillingCycle-UtilityBilling">
    <mat-card-header fxLayoutAlign="space-between center">
        Billing Cycle Progress -

        <lgd-select fxFlex="50" controlName="billingCycle" label="Billing Cycle and Period"
                    placeholder="Select a Billing Cycle and Period" [options]="billingCyclesObservable">
        </lgd-select>

        <button mat-button (click)="loadCycles()" matTooltip="Refresh Billing Periods"
                aria-label="Refresh-BillingPeriods-UtilityBilling">
            <mat-icon>cached</mat-icon>
        </button>
    </mat-card-header>

    <mat-card-content fxLayout="column" fxLayoutAlign="space-between stretch">
        <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>

        <div *ngIf="!hasData">Not Enough Data to Display</div>

        <mat-horizontal-stepper *ngIf="hasData" fxFlex="90" [selectedIndex]="selectedStep">

            <mat-step>
                <ng-template matStepLabel>Meters</ng-template>

                <div class="mt10">

                    <span [ngStyle]="getHeaderStyle(meterReadingData)">

                        <span *ngIf="!isLinkable(meterReadingData)">
                            {{meterReadingData.Title}}
                        </span>

                        <a *ngIf="isLinkable(meterReadingData)" (click)="launch(meterReadingData)"
                           [attr.telemetry]="getAriaLabel(meterReadingData)">
                            {{meterReadingData.Title}}
                        </a>

                    </span>

                    <div fxLayout="row">
                        <div *ngFor="let dataElement of meterReadingData.DataElements" fxFlex>
                            <labeled-field [label]="dataElement.Label">
                                <truncate-text [mainText]="dataElement.Value">
                                </truncate-text>
                            </labeled-field>
                        </div>
                    </div>
                </div>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>Billing</ng-template>

                <div class="mt10">
                    <span [ngStyle]="getHeaderStyle(billingData)">

                        <span *ngIf="!isLinkable(billingData)">
                            {{billingData.Title}}
                        </span>

                        <span *ngIf="isLinkable(billingData)" (click)="launch(billingData)"
                              [attr.telemetry]="getAriaLabel(billingData)">
                            {{billingData.Title}}
                        </span>
                    </span>
                    <div fxLayout="row" layout-wrap>
                        <div *ngFor="let dataElement of billingData.DataElements" fxFlex="auto">
                            <labeled-field [label]="dataElement.Label">
                                <truncate-text [mainText]="dataElement.Value">
                                </truncate-text>
                            </labeled-field>
                        </div>
                    </div>
                </div>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>Past Due</ng-template>

                <div class="mt10">
                    <div *ngFor="let pastDueCard of pastDueData" fxFlex="auto">
                        <span [ngStyle]="getHeaderStyle(pastDueCard)">

                            <span *ngIf="!isLinkable(pastDueCard)">
                                {{pastDueCard.Title}}
                            </span>

                            <a *ngIf="isLinkable(pastDueCard)" (click)="launch(pastDueCard)"
                               [attr.telemetry]="getAriaLabel(pastDueCard)">
                                {{pastDueCard.Title}}
                            </a>
                        </span>

                        <div fxLayout="row" layout-wrap>
                            <ng-container *ngFor="let dataElement of pastDueCard.DataElements">
                                <div *ngIf="dataElement.Visible" fxFlex="auto">
                                    <labeled-field [label]="dataElement.Label">
                                        <truncate-text [mainText]="dataElement.Value">
                                        </truncate-text>
                                    </labeled-field>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </mat-step>

        </mat-horizontal-stepper>
    </mat-card-content>
</mat-card>